export default __webpack_public_path__ + "static/media/icon-lightning.aa58b418.svg";